'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import type { BaseArticle } from '@/app_lib/types/Article';

const StnVideo = dynamic(() => import('@/app_components/common/StnVideo').then((mod) => mod.StnVideo), {
  loading: () => <div className='h-full aspect-video w-full animate-pulse bg-helper' />,
});

const Placeholder = () => (
  <div className='flex flex-col gap-6'>
    <div className='flex flex-col items-center gap-4 animate-pulse bg-helper self-center'>
      <span className='typography-level-3 font-graphik-compact font-semibold invisible'>Recommended Video</span>
      <hr className='w-[150px] self-center border-t-4 border-transparent md:w-50' />
    </div>
    <div className='h-full aspect-video w-full animate-pulse bg-helper' />
  </div>
);

export const RelatedVideo = ({ adTags, relatedVideoId }: Pick<BaseArticle, 'relatedVideoId' | 'adTags'>) => {
  const [displayVideo, setDisplayVideo] = useState(false);
  const [vodRef, inViewPort] = useInView({ threshold: 0 });

  useEffect(() => {
    if (inViewPort) {
      setDisplayVideo(true);
    }
  }, [inViewPort]);

  return (
    <div
      id='related-video'
      ref={vodRef}
    >
      {displayVideo ? (
        <div className='flex flex-col gap-6'>
          <div className='flex flex-col items-center gap-4'>
            <span className='typography-level-3 font-graphik-compact font-semibold'>Recommended Video</span>
            <hr className='w-[150px] self-center border-t-4 stroke-red md:w-50' />
          </div>
          <StnVideo
            adTags={adTags.edges}
            videoId={relatedVideoId}
          />
        </div>
      ) : (
        <Placeholder />
      )}
    </div>
  );
};
